export const FILTERS_REQUEST = 'FILTERS_REQUEST';
export const FILTERS_SUCCESS = 'FILTERS_SUCCESS';
export const FILTERS_FAILURE = 'FILTERS_FAILURE';

function filtersRequest() {
  return {
    type: FILTERS_REQUEST,
  };
}

function filtersFailure(error) {
  return {
    type: FILTERS_FAILURE,
    payload: { error },
  };
}

function filtersSuccess(filters) {
  return {
    type: FILTERS_SUCCESS,
    payload: { filters },
  };
}

export function readFilters() {
  return dispatch => {
    dispatch(filtersRequest());

    return fetch('/api/filters', {
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(filtersFailure(error))
      )
      .then(
        filters => dispatch(filtersSuccess(filters)),
        error => dispatch(filtersFailure(error))
      );
  };
}




// WEBPACK FOOTER //
// ./client/src/actions/filters.js